import React from "react";
import { useQuery, useQueryClient } from "react-query";
import axios from "axios";
import { Button } from "components/button";
import { QboClass, Division } from "../index";

type Props = {
    onClose: () => void;
};

const ClassMappingModal: React.FC<Props> = ({ onClose }) => {
    const queryClient = useQueryClient();

    const { data: divisions = [] } = useQuery("qbo-divisions", async () => {
        const res = await axios.get(
            `${process.env.REACT_APP_SERVER_URL}/api/v1/company/quickbooks-online/local-divisions`
        );
        return res.data;
    });

    const { data: qboClasses = [] } = useQuery("qbo-classes", async () => {
        const res = await axios.get(
            `${process.env.REACT_APP_SERVER_URL}/api/v1/company/quickbooks-online/local-classes`
        );
        return res.data;
    });

    const handleMapClass = async (divisionId: number, qboClassId: string) => {
        await axios.post(
            `${process.env.REACT_APP_SERVER_URL}/api/v1/company/quickbooks-online/map-classes`,
            {
                divisionId,
                qboClassId,
            }
        );
        await queryClient.invalidateQueries("qbo-divisions");
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg p-6 w-[600px] max-h-[80vh] overflow-y-auto">
                <h2 className="text-xl font-semibold mb-4">
                    Map Divisions to QBO Classes
                </h2>

                <div className="max-h-[50vh] overflow-y-auto">
                    <table className="w-full text-sm">
                        <thead>
                            <tr>
                                <th className="text-left py-2">Division</th>
                                <th className="text-left py-2">Mapped QBO Class</th>
                            </tr>
                        </thead>
                        <tbody>
                            {divisions
                                .slice()
                                .sort((a: any, b: any) => a.label.localeCompare(b.label))
                                .map((division: Division) => (
                                    <tr key={division.id}>
                                        <td className="py-2">{division.label}</td>
                                        <td className="py-2">
                                            <select
                                                className="border rounded px-2 py-1 w-full"
                                                value={division.qbo_class_id || ""}
                                                onChange={(e) =>
                                                    handleMapClass(division.id, e.target.value)
                                                }
                                            >
                                                <option value="">-- Unmapped --</option>
                                                {qboClasses.map((qbo: QboClass) => (
                                                    <option key={qbo.qbo_class_id} value={qbo.qbo_class_id}>
                                                        {qbo.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </td>
                                    </tr>
                                ))}

                        </tbody>
                    </table>
                </div>

                <div className="flex justify-end mt-6">
                    <Button
                        className="ml-2"
                        onClick={async () => {
                            await axios.get(
                                `${process.env.REACT_APP_SERVER_URL}/api/v1/company/quickbooks-online/remote-classes`
                            );
                            await queryClient.invalidateQueries("qbo-classes");
                        }}
                    >
                        Get Classes
                    </Button>

                    <Button className="ml-2" onClick={onClose}>Close</Button>
                </div>
            </div>
        </div>
    );
};

export default ClassMappingModal;
